// 添加样式依赖
import '@/common/css/index.scss';
import './index.scss';
// 添加js依赖
import $ from 'jquery';

import 'swiper/swiper-bundle.css';
// core version + navigation modules:
import Swiper, { Navigation } from 'swiper/core';

// configure Swiper to use modules
Swiper.use([Navigation]);

$(() => {
  // init Swiper:
  new Swiper('.swiper-container', {
    loop: true,
    slidesPerView: 3,
    // centeredSlides: true,
    // centeredSlidesBounds: true,
    spaceBetween: 20,
    // // Navigation arrows
    navigation: {
      nextEl: '.swiper-next',
      prevEl: '.swiper-prev'
    }
  });
});
